import { App, Button, Popconfirm, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDeleteAssistantMutation } from '@entities/assistant';
import { extractErrorMessage } from '@shared/api';

const { Text } = Typography;

interface Props {
  assistantId: string;
  assistantName: string;
}

/**
 * Удаление ассистента. После успеха ведёт на /assistants.
 *
 * V2-1: деньги лежат на балансе аккаунта, а не ассистента — при удалении
 * ассистента баланс сохраняется, предупреждение о сгорании бонуса не нужно.
 */
export function DeleteAssistantButton({ assistantId, assistantName }: Props) {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const mutation = useDeleteAssistantMutation();

  const handleConfirm = async () => {
    try {
      await mutation.mutateAsync(assistantId);
      message.success(`Ассистент «${assistantName}» удалён`);
      navigate('/');
    } catch (err) {
      message.error(extractErrorMessage(err));
    }
  };

  const description = (
    <div style={{ maxWidth: 320 }}>
      <div>
        Вместе с ассистентом удалятся его база знаний и история тест-чатов.
        Действие необратимо.
      </div>
      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 8 }}>
        Баланс аккаунта сохранится — он общий для всех ассистентов.
      </Text>
    </div>
  );

  return (
    <Popconfirm
      title="Удалить ассистента?"
      description={description}
      okText="Удалить"
      cancelText="Отмена"
      okButtonProps={{ danger: true, loading: mutation.isPending }}
      onConfirm={handleConfirm}
      placement="topRight"
    >
      <Button danger>Удалить ассистента</Button>
    </Popconfirm>
  );
}
